import staticContext from '../static/getContext';
import getblcktiveContext from 'src/shared/getblcktiveContext';
import { isString } from 'utils/is';

export default function getContext(node, options) {
  if (!node) return getblcktiveContext(this);

  if (isString(node)) {
    node = this.find(node, options);
  }

  return staticContext(node);
}
